import { Component, OnInit } from '@angular/core';
import { LookupEnvironmentService } from '../../services/lookup-environment.service';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
	versionNumber: string;

	constructor(private env_srv: LookupEnvironmentService) {
	}

	ngOnInit() {
		this.env_srv.fetchConfig().subscribe((config) => {
			this.versionNumber = config['versionNumber'];
		});
	}

}
